import React, { useState } from 'react';
import { CheckCircle2Icon, MailIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
export function Contact() {
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success'>('idle');
  const [form, setForm] = useState({
    name: '',
    email: '',
    topic: 'Editorial',
    message: ''
  });
  const [errors, setErrors] = useState<Record<string, string>>({});
  function validate() {
    const next: Record<string, string> = {};
    if (!form.name.trim()) next.name = 'Please enter your name.';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) next.email = 'Enter a valid email address.';
    if (form.message.trim().length < 10) next.message = 'Please include at least 10 characters.';
    setErrors(next);
    return Object.keys(next).length === 0;
  }
  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!validate()) return;
    setStatus('submitting');
    setTimeout(() => setStatus('success'), 900);
  }
  const field = 'w-full rounded-sm border border-stone-300 bg-white px-4 py-3 text-sm text-ink placeholder:text-stone-400 focus:border-trust-500 focus:outline-none focus:ring-1 focus:ring-trust-500';
  return <>
      <PageHeader eyebrow="Contact" title="Get in touch with the editorial team" intro="Questions about our methodology, a correction, or a partnership enquiry — we read every message." data-id="element-263" />

      <section className="max-w-editorial mx-auto px-6 pb-24 grid lg:grid-cols-12 gap-12" data-id="element-264">
        <div className="lg:col-span-5" data-id="element-265">
          <div className="rounded-sm border border-stone-200 bg-white p-8" data-id="element-266">
            <MailIcon className="h-7 w-7 text-trust-600" strokeWidth={1.5} data-id="element-267" />
            <h2 className="mt-5 font-serif text-xl tracking-tightest text-ink" style={{
            fontWeight: 600
          }} data-id="element-268">
              Editorial & Corrections
            </h2>
            <p className="mt-3 text-sm text-stone-600 leading-relaxed" data-id="element-269">
              We hold ourselves to the standards in the Agreexa Trust
              Framework®. If you spot an error, tell us — corrections are
              published transparently.
            </p>
            <p className="mt-6 text-sm text-stone-500" data-id="element-270">
              editorial@homeindependencehub.com
            </p>
          </div>
        </div>

        <div className="lg:col-span-7" data-id="element-271">
          {status === 'success' ? <div className="rounded-sm border border-trust-200 bg-trust-50 p-10 text-center" data-id="element-272">
              <CheckCircle2Icon className="h-10 w-10 text-trust-600 mx-auto" data-id="element-273" />
              <h2 className="mt-4 font-serif text-2xl tracking-tightest text-ink" style={{
            fontWeight: 500
          }} data-id="element-274">
                Thank you — message received.
              </h2>
              <p className="mt-3 text-stone-600" data-id="element-275">
                A member of the editorial team will be in touch shortly.
              </p>
            </div> : <form onSubmit={handleSubmit} noValidate className="space-y-5" data-id="element-276">
              <div className="grid sm:grid-cols-2 gap-5" data-id="element-277">
                <div data-id="element-278">
                  <label htmlFor="name" className="block text-sm font-600 text-ink mb-1.5" data-id="element-279">
                    Name
                  </label>
                  <input id="name" className={field} value={form.name} onChange={e => setForm({
                ...form,
                name: e.target.value
              })} aria-invalid={!!errors.name} data-id="element-280" />
                  {errors.name && <p className="mt-1 text-xs text-red-600" data-id="element-281">{errors.name}</p>}
                </div>
                <div data-id="element-282">
                  <label htmlFor="email" className="block text-sm font-600 text-ink mb-1.5" data-id="element-283">
                    Email
                  </label>
                  <input id="email" type="email" className={field} value={form.email} onChange={e => setForm({
                ...form,
                email: e.target.value
              })} aria-invalid={!!errors.email} data-id="element-284" />
                  {errors.email && <p className="mt-1 text-xs text-red-600" data-id="element-285">{errors.email}</p>}
                </div>
              </div>

              <div data-id="element-286">
                <label htmlFor="topic" className="block text-sm font-600 text-ink mb-1.5" data-id="element-287">
                  Topic
                </label>
                <select id="topic" className={field} value={form.topic} onChange={e => setForm({
              ...form,
              topic: e.target.value
            })} data-id="element-288">
                  <option data-id="element-289">Editorial</option>
                  <option data-id="element-290">Correction</option>
                  <option data-id="element-291">Partnership</option>
                  <option data-id="element-292">General enquiry</option>
                </select>
              </div>

              <div data-id="element-293">
                <label htmlFor="message" className="block text-sm font-600 text-ink mb-1.5" data-id="element-294">
                  Message
                </label>
                <textarea id="message" rows={5} className={field} value={form.message} onChange={e => setForm({
              ...form,
              message: e.target.value
            })} aria-invalid={!!errors.message} data-id="element-295" />
                {errors.message && <p className="mt-1 text-xs text-red-600" data-id="element-296">{errors.message}</p>}
              </div>

              <button type="submit" disabled={status === 'submitting'} className="inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-600 rounded-sm bg-ink text-paper hover:bg-trust-700 transition-colors disabled:opacity-60" data-id="element-297">
                {status === 'submitting' ? 'Sending…' : 'Send message'}
              </button>
            </form>}
        </div>
      </section>
    </>;
}